<template>
	<v-card elevation="0" outlined class="pa-1 mt-0">
		<v-row no-gutters class="mb-2 d-flex" style="justify-content: flex-end"
			><v-btn
				v-if="
					(canEdit && newInteraction == false) ||
					(canAdd && newInteraction == true)
				"
				color="error"
				height="26px"
				width="26px"
				@click="remove()"
				x-small
				><v-icon>mdi-window-close</v-icon></v-btn
			></v-row
		>
		<v-form ref="form">
			<v-row no-gutters>
				<v-select
					:rules="dataFieldRules"
					class="mb-2"
					v-model="condition.FormFieldId"
					outlined
					dense
					hide-details="true"
					:items="formFields"
					item-text="Label"
					item-value="Id"
					label="Form field"
				>
				</v-select>
			</v-row>
			<v-row no-gutters>
				<v-select
					outlined
					dense
					v-model="condition.Operator"
					:items="operators"
					class="operatorDropdown"
					item-value="value"
					item-text="text"
					hide-details="true"
					label="Operator"
				></v-select>
				<v-text-field
					:rules="valueRules"
					v-model="condition.Value"
					class="mt-2"
					dense
					outlined
					hide-details="true"
					label="Value"
					v-if="showValue"
				></v-text-field>
			</v-row>
		</v-form>
	</v-card>
</template>
<script>
import {
	InventoryFormOperator,
	InventoryFormOperatorTypes,
} from '../../../../enums/inventoryFormOperator';
import { mapGetters } from 'vuex';
import { InteractionsGetters } from '../../../../store/getters';
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import { Permissions } from '../../../../enums/permissionsEnum';
import permissionsMixin from '../../../../mixins/permissionsMixin';
export default {
	name: 'FormCondition',
	mixins: [permissionsMixin],
	data() {
		return {
			dataFieldRules: [(v) => !!v || 'Data field is required'],
			valueRules: [
				(v) => (!!v && this.showValue == true) || 'Value is required',
			],
			operators: InventoryFormOperatorTypes,
		};
	},
	props: {
		newInteraction: Boolean,
		index: Number,
		condition: Object,
	},
	computed: {
		...mapGetters({
			formFields: [InteractionsGetters.FORM_FIELDS],
		}),
		canAdd() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Interactions.Add,
			]);
		},
		canEdit() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Interactions.Edit,
			]);
		},
		showValue() {
			switch (this.condition.Operator) {
				case InventoryFormOperator.IsAnything:
				case InventoryFormOperator.IsBlank:
					return false;
			}
			return true;
		},
	},
	watch: {
		'condition.Operator'(newValue) {
			switch (newValue) {
				case InventoryFormOperator.IsAnything:
				case InventoryFormOperator.IsBlank:
					this.condition.Value = null;
			}
		},
	},
	methods: {
		remove() {
			ConfirmDialog({
				message: 'Are you sure you want to delete this condition?',
			}).then((isDelete) => {
				if (isDelete) {
					this.$emit('remove', this.index);
				}
			});
		},
		validate() {
			return this.$refs.form.validate();
		},
	},
};
</script>
<style>
.operatorDropdown {
	width: 100%;
}
</style>
